import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Modal, ModalBody,
  Input, FormGroup
} from 'reactstrap'

import CustomPagination from 'components/Pagination'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import SearchForm from './SearchForm'
import PageTitle from 'components/Title/PageTitle'

import PortalUsersHOC from './action'
import ImageDownloader from 'components/ImageZip'

import Lang from 'Lang/General'

const PortalUsers = props => {

  useEffect(() => {
    props.getCompanies()
    props.getFairs()
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeMediaHOC('subscribedPackage', tmpIndex > -1)
  }, [])

  useEffect(() => {
    let temp = _.cloneDeep(props.searchParams)
    temp[0]['options'] = props.companies
    temp[1]['options'] = props.fairs

    props.onChangeMediaHOC('searchParams', temp)
  }, [props.companies, props.fairs])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const onHandleCheck = param => {
    let tempDownload = _.cloneDeep(props.selectedtoDownload)
    let tempIndex = _.findIndex(props.selectedtoDownload, val => (val.id === param.id && val.media_type === param.media_type))
    if (tempIndex < 0) {
      tempDownload.push(param)
    } else {
      tempDownload.splice(tempIndex, 1)
    }

    props.onChangeMediaHOC('selectedtoDownload', tempDownload)
  }

  const onHandleCheckAll = () => {
    if (props.selectedtoDownload.length === props.mediaMeta.total_results) {
      return props.onChangeMediaHOC('selectedtoDownload', [])
    }

    return props.onChangeMediaHOC('selectedtoDownload', [
      ...props.selectedtoDownload,
      ...props.medias
    ])
  }

  return (
    <>
      <PageTitle
        heading={Lang['MEDIA'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-photo icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <div className="mb-2">
          </div>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangeMediaHOC}
                onReset={() => {
                  props.onChangeMediaHOC('selectedtoDownload', [])
                  props.onChangeMediaHOC('medias', [])
                }}
                getListAPI={val => {
                  props.onChangeMediaHOC('selectedtoDownload', [])
                  props.getMedia({
                    ...val,
                    filter: {
                      ...val.filter,
                      "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id
                    },
                    is_paginated: false
                  })
                }}
                defaultSearchParams={[
                  {
                    label: Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language],
                    col: 6,
                    value: 'filter_company_names',
                    param: '',
                    type: 'multi-select',
                    options: props.companies
                  },
                  {
                    label: Lang['FAIR_SHORT'][props.data.languageReducer.userSettings.admin_panel_language],
                    value: 'filter_fair_short_titles',
                    col: 6,
                    param: '',
                    type: 'multi-select',
                    options: props.fairs
                  },
                  {
                    label: '',
                    value: 'media_type',
                    col: 12,
                    param: [
                      'want_logo',
                      'want_image_1',
                      'want_image_2',
                      'want_press_release_1',
                      'want_press_release_2',
                      'want_portrait',
                    ],
                    type: 'checkbox',
                    options: [
                      {
                        id: 'want_logo',
                        name: `${Lang['LOGO'][props.data.languageReducer.userSettings.admin_panel_language]}`
                      },
                      {
                        id: 'want_image_1',
                        name: `${Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]} 1`
                      },
                      {
                        id: 'want_image_2',
                        name: `${Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]} 2`
                      },
                      {
                        id: 'want_press_release_1',
                        name: `${Lang['PRESS_RELEASE'][props.data.languageReducer.userSettings.admin_panel_language]} 1`
                      },
                      {
                        id: 'want_press_release_2',
                        name: `${Lang['PRESS_RELEASE'][props.data.languageReducer.userSettings.admin_panel_language]} 2`
                      },
                      {
                        id: 'want_portrait',
                        name: `${Lang['PORTRAIT'][props.data.languageReducer.userSettings.admin_panel_language]}`
                      },
                    ]
                  },
                ]}
                defaultQuery={{
                  page: 1,
                  is_paginated: false,
                  filter: {
                    "want_logo": true,
                    "want_image_1": true,
                    "want_image_2": true,
                    "want_press_release_1": false,
                    "want_press_release_2": true,
                    "want_portrait": true,
                    "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
                  }
                }}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ImageDownloader
                  imageUrls={props.selectedtoDownload}
                  allImageUrls={props.medias}
                  lang={props.data.languageReducer.userSettings.admin_panel_language}
                  style={{ marginLeft: 'auto', marginBottom: 20 }}
                  onHandleLoading={val => props.onChangeMediaHOC('loading', val)}
                />
                <ReactTable
                  defaultPageSize={10}
                  showPagination={true}
                  NoDataComponent={() => <span></span>}
                  data={props.medias}
                  columns={[
                    {
                      Header: <>
                        <Input
                          type={'checkbox'}
                          checked={props.selectedtoDownload.length > 0 && props.selectedtoDownload.length === props.mediaMeta.total_results}
                          onChange={() => onHandleCheckAll()}
                        />
                        <span className='ml-1'>{Lang['SELECT_ALL'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </>,
                      Cell: (row, index) => (
                        <FormGroup
                          check
                          className={'d-flex justify-content-center w-100 align-items-center'}
                        >
                          <Input
                            type={'checkbox'}
                            checked={_.findIndex(props.selectedtoDownload, child => (child.id === row.original.id && child.media_type === row.original.media_type)) > -1}
                            onChange={() => onHandleCheck(row.original)}
                          />
                        </FormGroup>
                      )
                    },
                    {
                      Header: Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'company'
                    },
                    {
                      Header: Lang['FAIR_SHORT'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'fair_short_title',
                    },
                    {
                      Header: Lang['MEDIA_TYPE'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'media_type'
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          <Button
                            className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                            color='primary'
                            onClick={() => window.open(row.original.url)} >
                            <i className="pe-7s-cloud-download btn-icon-wrapper" />
                          </Button>
                          {
                            row.original.url.indexOf('pdf') < 0 && (
                              <Button
                                className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                color='primary'
                                onClick={() => {
                                  props.onChangeMediaHOC('selectedMedia', row.original)
                                }} >
                                <i className="pe-7s-look btn-icon-wrapper" />
                              </Button>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
                {/* <CustomPagination
                  meta={props.mediaMeta || {}}
                  onChangePage={val => {
                    props.getMedia({
                      ...props.query,
                      page: val,
                    })
                  }}
                /> */}
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      <Modal
        isOpen={props.selectedMedia !== null}
        toggle={() => props.onChangeMediaHOC('selectedMedia', null)}
      >
        <ModalBody>
          <img
            src={props.selectedMedia?.url} alt=""
            style={{ width: '100%', height: '100%' }}

          />
        </ModalBody>
      </Modal>
      {props.onLoadMedia && <LoadingOverlay />}
    </>
  )
}

export default PortalUsersHOC(PortalUsers)
